( function () {
    'use strict';
    espresso.bootstrap = espresso.bootstrap || {};
    espresso.bootstrap.dropdown = {};
    espresso.bootstrap.dropdown.fixTouchClickIssue = function () {
        jQuery( 'body' ).on( 'touchstart.dropdown', '.dropdown-menu', function ( event ) {
            event.stopPropagation();
        } ).on( 'click', '.dropdown-menu a', function ( event ) {
            event.stopPropagation();
        } );
        /*$('.dropdown-menu').click(function(event){
        event.stopPropagation();
        } );*/
    };
}() );
